export default __webpack_public_path__ + "static/media/D.642cba28.svg";